import React, { useState } from 'react'
import { JOURS, formatSemaine } from '../lib/helpers'

export default function ExportPDF({ defis, saisies, semaine, pseudonyme, estEcole, recompenses = [] }) {
  const [loading, setLoading] = useState(false)

  const generer = () => {
    setLoading(true)
    const defisAffiches = defis.filter(d => {
      if (!d.actif) return false
      if (estEcole) return d.type === 'ecole'
      return d.type !== 'ecole'
    })

    const getVal = (jour, defiId) => saisies[`${semaine}-${jour}-${defiId}`] || 0

    const totalParJour = (jour) =>
      defisAffiches.reduce((s, d) => s + getVal(jour, d.id), 0) +
      (!estEcole ? (saisies[`${semaine}-${jour}-bonus`] || 0) : 0)

    const maxParJour = defisAffiches.reduce((s, d) => s + d.points, 0) + (!estEcole ? 5 : 0)

    const totalSemaine = JOURS.reduce((s, j) => s + totalParJour(j), 0)

    const recompensesHTML = !estEcole && recompenses.length > 0 ? `
      <div class="recompenses-section">
        <h2>🎁 Récompenses</h2>
        <p class="recomp-hint">Cochez les récompenses obtenues cette semaine</p>
        <div class="recomp-grid">
          ${recompenses.map(r => `
            <label class="recomp-card">
              <input type="checkbox" class="recomp-check" />
              <div class="recomp-emoji">${r.emoji}</div>
              <div class="recomp-label">${r.label}</div>
              <div class="recomp-pts">${r.points} ⭐</div>
            </label>
          `).join('')}
        </div>
      </div>
    ` : ''

    const html = `<!DOCTYPE html>
<html lang="fr">
<head>
<meta charset="UTF-8">
<title>KudoGenius — ${pseudonyme}</title>
<style>
  @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@400;700;800;900&display=swap');
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { font-family: 'Nunito', sans-serif; padding: 32px; color: #1a2e5a; background: #fff; }
  .header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 24px; border-bottom: 3px solid #2d7dd2; padding-bottom: 16px; }
  .logo { font-size: 24px; font-weight: 900; color: #1a2e5a; }
  .logo span { color: #2d7dd2; }
  .meta { text-align: right; font-size: 13px; color: #6b7280; }
  .meta strong { color: #1a2e5a; font-size: 16px; display: block; margin-bottom: 4px; }
  h2 { font-size: 18px; font-weight: 800; color: #1a2e5a; margin-bottom: 16px; }
  table { width: 100%; border-collapse: collapse; font-size: 12px; }
  th { background: #1a2e5a; color: #fff; padding: 8px 6px; text-align: center; font-weight: 700; }
  th.defi-col { text-align: left; padding-left: 12px; min-width: 140px; }
  th.pts-col { width: 40px; }
  td { border: 1px solid #dbeafe; padding: 7px 6px; text-align: center; vertical-align: middle; }
  td.defi-col { text-align: left; padding-left: 12px; font-weight: 700; background: #f8faff; }
  td.pts-col { color: #2d7dd2; font-weight: 800; background: #f0f6ff; }
  .val { width: 28px; height: 28px; border-radius: 50%; display: inline-flex; align-items: center; justify-content: center; font-weight: 800; font-size: 12px; }
  .val-ok { background: #22c55e; color: #fff; }
  .val-empty { background: #f0f0f0; color: #ccc; width: 28px; height: 28px; border-radius: 50%; display: inline-block; border: 2px dashed #ddd; }
  .total-row td { background: #1a2e5a; color: #fff; font-weight: 800; }
  .bonus-row td { background: #fffbeb; }
  .bonus-row td.defi-col { color: #92400e; }
  .footer { margin-top: 24px; font-size: 11px; color: #9ca3af; text-align: center; border-top: 1px solid #e5e7eb; padding-top: 12px; }
  .badge-semaine { background: #dbeafe; color: #1a5fa8; border-radius: 20px; padding: 4px 14px; font-size: 12px; font-weight: 700; display: inline-block; margin-bottom: 16px; }

  /* Récompenses */
  .recompenses-section { margin-top: 32px; padding-top: 24px; border-top: 2px dashed #e2e8f0; }
  .recomp-hint { font-size: 12px; color: #94a3b8; margin-bottom: 16px; font-style: italic; }
  .recomp-grid { display: flex; flex-wrap: wrap; gap: 12px; }
  .recomp-card {
    display: flex; flex-direction: column; align-items: center;
    border: 2px solid #e2e8f0; border-radius: 14px; padding: 14px 16px;
    cursor: pointer; min-width: 110px; flex: 1; max-width: 150px;
    transition: all 0.15s; position: relative; user-select: none;
  }
  .recomp-check {
    position: absolute; top: 10px; right: 10px;
    width: 18px; height: 18px; cursor: pointer; accent-color: #7c3aed;
  }
  .recomp-card:has(.recomp-check:checked) {
    border-color: #7c3aed; background: #faf5ff;
  }
  .recomp-card:has(.recomp-check:checked)::after {
    content: '✓ Obtenue !';
    position: absolute; bottom: -1px; left: 0; right: 0;
    background: #7c3aed; color: #fff; font-size: 10px; font-weight: 800;
    text-align: center; padding: 3px 0; border-radius: 0 0 12px 12px;
  }
  .recomp-emoji { font-size: 32px; margin-bottom: 6px; margin-top: 4px; }
  .recomp-label { font-weight: 800; font-size: 12px; color: #1e293b; text-align: center; margin-bottom: 4px; }
  .recomp-pts { font-size: 12px; color: #7c3aed; font-weight: 800; }

  @media print {
    body { padding: 16px; }
    button { display: none !important; }
    .recomp-card { break-inside: avoid; }
  }
</style>
</head>
<body>
<div class="header">
  <div class="logo">Kudo<span>Genius</span> ⭐</div>
  <div class="meta">
    <strong>${pseudonyme || 'Mon enfant'}</strong>
    ${estEcole ? '🏫 Vue École' : '🏠 Vue Parents'}
  </div>
</div>

<div class="badge-semaine">📅 ${formatSemaine(semaine)}</div>
<h2>${estEcole ? '🏫 Défis école' : '📋 Tableau de valorisation'}</h2>

<table>
  <thead>
    <tr>
      <th class="defi-col">Défi</th>
      <th class="pts-col">Pts</th>
      ${JOURS.map(j => `<th>${j}</th>`).join('')}
      <th>Total</th>
    </tr>
  </thead>
  <tbody>
    ${defisAffiches.map(d => {
      const totalDefi = JOURS.reduce((s, j) => s + getVal(j, d.id), 0)
      return `<tr>
        <td class="defi-col">${d.emoji} ${d.label}</td>
        <td class="pts-col">${d.points}</td>
        ${JOURS.map(j => {
          const v = getVal(j, d.id)
          return `<td>${v > 0
            ? `<span class="val val-ok">${v}</span>`
            : `<span class="val-empty"></span>`
          }</td>`
        }).join('')}
        <td style="font-weight:800;color:#2d7dd2">${totalDefi}</td>
      </tr>`
    }).join('')}

    ${!estEcole ? `<tr class="bonus-row">
      <td class="defi-col">🌟 Bonus</td>
      <td class="pts-col" style="color:#d97706">+</td>
      ${JOURS.map(j => {
        const v = saisies[`${semaine}-${j}-bonus`] || 0
        return `<td>${v > 0 ? `<span class="val val-ok">${v}</span>` : '<span class="val-empty"></span>'}</td>`
      }).join('')}
      <td style="font-weight:800;color:#d97706">${JOURS.reduce((s, j) => s + (saisies[`${semaine}-${j}-bonus`] || 0), 0)}</td>
    </tr>` : ''}

    ${estEcole ? `<tr class="bonus-row">
      <td class="defi-col">🌟 Bonus</td>
      <td class="pts-col" style="color:#d97706">+</td>
      ${JOURS.map(j => {
        const v = saisies[`${semaine}-${j}-bonus_ecole`] || 0
        return `<td>${v > 0 ? `<span class="val val-ok">${v}</span>` : '<span class="val-empty"></span>'}</td>`
      }).join('')}
      <td style="font-weight:800;color:#d97706">${JOURS.reduce((s, j) => s + (saisies[`${semaine}-${j}-bonus_ecole`] || 0), 0)}</td>
    </tr>` : ''}

    ${!estEcole ? `<tr class="nutry-row">
      <td class="defi-col">🥗 NutryGenius</td>
      <td class="pts-col" style="color:#0369a1">+</td>
      ${JOURS.map(() => '<td><span class="val-empty"></span></td>').join('')}
      <td></td>
    </tr>` : ''}

    <tr class="respi-row">
      <td class="defi-col">🌬️ Respiration</td>
      <td class="pts-col" style="color:#7c3aed">+</td>
      ${JOURS.map(() => '<td><span class="val-empty"></span></td>').join('')}
      <td></td>
    </tr>

    <tr class="total-row">
      <td class="defi-col" colspan="2">Total journée</td>
      ${JOURS.map(j => `<td>${totalParJour(j)}</td>`).join('')}
      <td>${totalSemaine}</td>
    </tr>
  </tbody>
</table>

${recompensesHTML}

<div class="footer">
  Tableau généré par KudoGenius — offert par NutryGenius® · kudogenius.com
</div>

<button onclick="window.print()" style="position:fixed;bottom:20px;right:20px;padding:12px 24px;background:#2d7dd2;color:#fff;border:none;border-radius:12px;font-size:15px;font-weight:700;cursor:pointer;font-family:sans-serif;box-shadow:0 4px 15px rgba(0,0,0,0.2);z-index:999">🖨️ Imprimer</button>
<button onclick="window.close()" style="position:fixed;bottom:20px;left:20px;padding:12px 24px;background:#1a2e5a;color:#fff;border:none;border-radius:12px;font-size:15px;font-weight:700;cursor:pointer;font-family:sans-serif;box-shadow:0 4px 15px rgba(0,0,0,0.2);z-index:999">← Retour</button>
</body>
</html>`

    const blob = new Blob([html], { type: 'text/html' })
    const url = URL.createObjectURL(blob)
    window.open(url, '_blank')
    setLoading(false)
  }

  return (
    <button
      onClick={generer}
      disabled={loading}
      style={{
        padding: '8px 18px', borderRadius: 12, border: 'none',
        background: '#1a2e5a', color: '#fff', fontSize: 13,
        fontWeight: 700, cursor: 'pointer', display: 'flex',
        alignItems: 'center', gap: 6, fontFamily: "'Nunito', sans-serif"
      }}
    >
      🖨️ {loading ? 'Génération...' : `Imprimer PDF ${estEcole ? 'école' : 'parents'}`}
    </button>
  )
}
